// extracted by mini-css-extract-plugin
export var chevronIcon = "_46-2";
export var teamName = "_46-1";
export var teamSwitcherButton = "_46-0";